import type { ExpertAssistMessage } from "../shared-types";
import { getMessage } from "./getMessages";
import { useTimelineStore } from "./timelineStore";

export const updateMessage = (sessionId: string, id: string, message: Partial<ExpertAssistMessage>) => {
    const currentMessage = getMessage(sessionId, id);
    if (!currentMessage) return;
    const updatedMessage = { ...currentMessage, ...message };
    useTimelineStore.getState().updateMessage(sessionId, id, updatedMessage);
};

export const deactivateMessage = (sessionId: string, id: string) => {
    useTimelineStore.getState().updateMessage(sessionId, id, {
        status: "deactivated",
    });
};

export const deactivatedSummaryMessage = "The previous session notes were removed.";
export const deactivatePreviousSessionSummaryMessage = (sessionId: string, timestamp: string) => {
    const { updateMessage, getTimelineState } = useTimelineStore.getState();
    const { messages } = getTimelineState(sessionId);
    /* find _last_ session summary message for timestamp - this ensures we're deactivating the most recent message in case a session summary message earlier in the timeline had the same timestamp */
    const existingPreviousSummaryMessage = messages
        .filter((msg) => msg.type === "SessionSummary" && msg.metadata?.sessionSummary?.timestamp === timestamp)
        .pop();
    if (!existingPreviousSummaryMessage || !existingPreviousSummaryMessage.metadata?.sessionSummary) {
        return;
    }
    deactivateMessage(sessionId, existingPreviousSummaryMessage.id);
    updateMessage(sessionId, existingPreviousSummaryMessage.id, {
        metadata: {
            sessionSummary: {
                ...existingPreviousSummaryMessage.metadata.sessionSummary,
                summary: deactivatedSummaryMessage,
                resolutionStatus: undefined,
            },
        },
        text: deactivatedSummaryMessage,
    });
};
